module.exports = __webpack_public_path__ + "img/potencia_r_a_red.04a5407b.svg";